import React from 'react';
import { node } from 'prop-types';

const Body = ({ children }) => <div className="modal-body">{children}</div>;

Body.propTypes = {
    children: node,
};

export default Body;
